exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-form-script .script-header[data-v-ccccba78]{display:flex;align-items:center;white-space:nowrap}.fts-form-script .script-header .script-header__indicator[data-v-ccccba78]{height:.375rem;width:.375rem;margin-right:.575rem;border-radius:10em;background-color:var(--fts-success)}", ""]);

// exports
